import { formControlLabelClasses } from '@mui/material';
import palette from '../theme/palette';

const styleOverrides = {
  root: {
    marginLeft: 0,
    marginRight: 0,
    '& > :nth-of-type(2)': {
      // OPTIMIZE: only when labelPlacement is unset or right - which is the only variant on Figma on 2022-08-17
      //  and 2022-11-23
      marginLeft: '8px',
    },
    // lower opacity of all siblings of the form control (i.e. the actual label(s))
    [`& .${formControlLabelClasses.disabled} + *`]: {
      opacity: 0.4,
    },
  },
  label: {
    [`&.${formControlLabelClasses.disabled}`]: {
      color: palette.text.primary,
    },
  },
};

export default styleOverrides;
